'use client';

import { useSearchParams } from 'next/navigation';

// Components
import Breadcrumb from 'components/Breadcrumb/Breadcrumb';
import VideocenterChannelWrapper from 'components/VideocenterChannel';

// utils
import { useXy } from 'utils/hooks/use-xy';
import { useNord } from 'utils/hooks/use-nord';
import { contentExists, useContent } from 'components/Page/page-hooks';

export function VideocenterChannel({
  channels,
}: Readonly<{
  channels: any[];
}>) {
  const isXy = useXy();
  const isNord = useNord();
  const isNordOrXy = isNord || isXy;
  const params = useSearchParams();
  const page = useContent();

  if (!contentExists(page)) {
    return null;
  }

  const { breadcrumbs } = page;
  const searchQueryChannelId = (params.get('channel') as string) || '';

  return (
    <>
      {isNordOrXy && <Breadcrumb items={breadcrumbs} />}
      <VideocenterChannelWrapper
        searchQueryChannelId={searchQueryChannelId}
        channels={channels}
        page={page}
      />
    </>
  );
}
